import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { AvatarComponent } from './components/avatar/avatar.component';
import { IconSelectorComponent } from './components/icon-selector/icon-selector.component';
import { LoadingLogoComponent } from './components/loading-logo/loading-logo.component';
import { NestedSelectComponent } from './components/nested-select/nested-select.component';
import {
	ProfilePictureSelectorComponent,
} from './components/profile-picture-selector/profile-picture-selector.component';
import {
	ResetPasswordDialogComponent,
} from './components/side-nav/reset-password-dialog/reset-password-dialog.component';
import { ScenarioNavComponent } from './components/side-nav/scenario-nav.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { SelectAllDirective } from './directives/select-all.directive';
import { StreamingInputDirective, StreamingTextInputDirective } from './directives/streaming-input.directive';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { FormatEnumPipe } from './pipes/format-enum.pipe';
import { FormatToolPipe } from './pipes/format-tool.pipe';

@NgModule({
	declarations: [
		FormatEnumPipe,
		SideNavComponent,
		ProfilePictureSelectorComponent,
		AvatarComponent,
		FormatToolPipe,
		ResetPasswordDialogComponent,
		NestedSelectComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		LoadingLogoComponent,
		MatIconModule,
		RouterModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatMenuModule,
		MatDividerModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		SelectAllDirective,
		StreamingInputDirective,
		StreamingTextInputDirective,
		IconSelectorComponent,
		CapitalizePipe,
		MatPseudoCheckboxModule,
		MatTooltip,
		ScenarioNavComponent,
	],
	providers: [CurrencyPipe],
	exports: [
		CommonModule,
		FormsModule,
		FormatEnumPipe,
		SideNavComponent,
		ProfilePictureSelectorComponent,
		AvatarComponent,
		FormatToolPipe,
		SelectAllDirective,
		CapitalizePipe,
		LoadingLogoComponent,
		NestedSelectComponent,
		StreamingInputDirective,
		StreamingTextInputDirective,
		IconSelectorComponent,
	],
})
export class SharedModule {}
